export default {
    computed: {
        getProductType() {
            return [
                { value: '1', label: this.$t('erp.setting.goods_type_0', { defaultValue: '成品' }) },
                { value: '2', label: this.$t('erp.setting.goods_type_1', { defaultValue: '配件' }) },
                { value: '3', label: this.$t('erp.setting.goods_type_2', { defaultValue: '耗材' }) },
            ]
        },
        getInventoryType() {
            return [
                { value: '0', label: this.$t('erp.product.normal_stock', { defaultValue: '正常库存' }) },
                { value: '1', label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }) },
            ]
        },
        getInventoryReserveSrcLabel () {
            return [
                { value: '0', label: this.$t('fbb.costmanage.unknown', { defaultValue: '未知' }) },
                { value: '10', label: this.$t('fbb.adjustment.list_sale', { defaultValue: '销售订单' }) },
                { value: '41', label: this.$t('fbb.inventory.return_storage', { defaultValue: '退货入库' }) },
                { value: '50', label: this.$t('fbb.alloment.alloment_out', { defaultValue: '调拨出库' }) },
                { value: '60', label: this.$t('fbb.inventory.unnormal_change', { defaultValue: '库存异动' }) },
                { value: '61', label: this.$t('fbb.inventory.keep_order', { defaultValue: '预留单' }) },
                { value: '70', label: this.$t('fbb.adjustment.list_destroy', { defaultValue: '销毁单' })},
                { value: '80', label: this.$t('fbb.transfer.transfer_outbount', { defaultValue: "转运出库" }) },
                { value: '106', label: this.$t('fbb.inventory.change_label_put', { defaultValue: "换标上架" }) },
            ]
        },
        getInventorySnapshotType () {
            return [
                { value: 'CAN_SALE', label: this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }) },
                { value: 'NO_SALE', label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }) },
            ]
        },
        getInventoryTaskOpType () {
            return [
                { value: '5', label: this.$t('fbb.headlogistics.chushihua', { defaultValue: '初始化' }) },
                { value: '10', label: this.$t('fbb.inventory.purchase_inbound', { defaultValue: '采购入库' }) },
                { value: '11', label: this.$t('fbb.adjustment.list_nosource', { defaultValue: '无来源入库' }) },
                { value: '13', label: this.$t('fbb.inventory.inbound_break', { defaultValue: '入库报损' }) },
                { value: '15', label: this.$t('fbb.inventory.inbound_out', { defaultValue: '入库报溢' }) },
                { value: '20', label: this.$t('fbb.inventory.back_receive', { defaultValue: '退货接收入库' }) },
                { value: '30', label: this.$t('fbb.alloment.alloment_in', { defaultValue: '调拨入库' }) },
                { value: '40', label: this.$t('fbb.alloment.alloment_out', { defaultValue: '调拨出库' }) },
                { value: '60', label: this.$t('fbb.inventory.other_inbound', { defaultValue: '其他入库' }) },
                { value: '70', label: this.$t('fbb.inventory.other_outbound', { defaultValue: '其他出库' }) },
                { value: '100', label: this.$t('fbb.inventory.sale_outbound', { defaultValue: '销售出库' }) },
                { value: '110', label: this.$t('fbb.inventory.warehouse_out', { defaultValue: '仓库移出' }) },
                { value: '120', label: this.$t('fbb.inventory.warehouse_in', { defaultValue: '仓库移入' }) },
                { value: '121', label: this.$t('fbb.inventory.outside_warehouse_in', { defaultValue: '仓库跨仓移入' }) },
                { value: '122', label: this.$t('fbb.inventory.outside_warehouse_out', { defaultValue: '仓库跨仓移出' }) },
                { value: '103', label: this.$t('fbb.inventory.change_warehouse_in', { defaultValue: '库存调整入库' }) },
                { value: '104', label: this.$t('fbb.inventory.change_warehouse_out', { defaultValue: '库存调整出库' }) },
                { value: '115', label: this.$t('fbb.transfer.transfer_inbound', { defaultValue: "转运入库" }) },
                { value: '116', label: this.$t('fbb.transfer.transfer_outbount', { defaultValue: "转运出库" }) },
                { value: '21', label: this.$t('fbb.transfer.return_outbound', { defaultValue: "退货出库" }) },
                { value: '125', label: this.$t('fbb.transfer.claim_inbound', { defaultValue: "认领入库" }) },
                { value: '126', label: this.$t('fbb.transfer.claim_outbound', { defaultValue: "认领出库" }) },
                { value: '105', label: this.$t('fbb.inventory.change_label_shelf', { defaultValue: "换标下架" }) },
                { value: '106', label: this.$t('fbb.inventory.change_label_put', { defaultValue: "换标上架" }) },

            ]
        },
        getInventoryTransportSrcLabel () {
            return [
                { value: '0', label: this.$t('fbb.costmanage.unknown', { defaultValue: '未知' }) },
                { value: '20', label: this.$t('fbb.inventory.purchase_inbound', { defaultValue: '采购入库' }) },
                { value: '40', label: this.$t('erp.aftersales.goods', { defaultValue: '退货' }) },
                { value: '60', label: this.$t('fbb.transfer.transfer_inbound', { defaultValue: "转运入库" }) },
                { value: '80', label: this.$t('fbb.allotmant.outbound', { defaultValue: '调拨入库单' }) },
                { value: '100', label: this.$t('fbb.inventory.claim_plan_form', { defaultValue: '认领计划单' }) },
            ]
        },
        getInventoryBatchListType () {
            return [
                { value: '5', label: this.$t('fbb.costmanage.unknown', { defaultValue: '未知' }) },
                { value: '10', label: this.$t('fbb.headlogistics.inbound', { defaultValue: '入库单' }) },
                { value: '20', label: this.$t('fbb.inventory.sale_back_inbound', { defaultValue: '销售退货入库' }) },
                { value: '30', label: this.$t('fbb.allotmant.outbound', { defaultValue: '调拨入库单' }) },
                { value: '60', label: this.$t('fbb.inventory.other_inbound_order', { defaultValue: '其他入库单' }) },
                { value: '120', label: this.$t('fbb.inventory.warehouse_in', { defaultValue: '仓库移入' }) },
                { value: '121', label: this.$t('fbb.inventory.outside_warehouse_in', { defaultValue: '仓库跨仓移入' }) },
                { value: '103', label: this.$t('fbb.inventory.change_warehouse_in', { defaultValue: '库存调整入库' }) },
                { value: '115', label: this.$t('fbb.transfer.transfer_inbound', { defaultValue: "转运入库" }) },
                { value: '125', label: this.$t('fbb.transfer.claim_inbound', { defaultValue: '认领入库' }) },
                { value: '126', label: this.$t('fbb.transfer.claim_outbound', { defaultValue: '认领出库' }) },
                { value: '105', label: this.$t('fbb.inventory.change_label_shelf', { defaultValue: "换标下架" }) },
                { value: '106', label: this.$t('fbb.inventory.change_label_put', { defaultValue: "换标上架" }) },
            ]
        },
        getInventoryBatchTaskType () {
            return [
                { value: '5', label: this.$t('fbb.inventory.stock_init', { defaultValue: '库存初始化' }) },
                { value: '10', label: this.$t('fbb.inboundorder.index', { defaultValue: '入库单' }) },
                { value: '11', label: this.$t('fbb.adjustment.list_nosource', { defaultValue: "无来源入库" }) },
                { value: '13', label: this.$t('fbb.inventory.inbound_damage', { defaultValue: '入库单报损' }) },
                { value: '15', label: this.$t('fbb.inventory.inbound_order_full', { defaultValue: '入库单报溢' }) },
                { value: '20', label: this.$t('fbb.inventory.sale_back_order', { defaultValue: '销售退货单' }) },
                { value: '30', label: this.$t('fbb.allotmant.outbound', { defaultValue: '调拨入库单' }) },
                { value: '40', label: this.$t('fbb.allotmant.inbound', { defaultValue: '调拨出库单' }) },
                { value: '60', label: this.$t('fbb.inventory.other_inbound_order', { defaultValue: '其他入库单' }) },
                { value: '70', label: this.$t('fbb.inventory.other_outbound', { defaultValue: '其他出库单' }) },
                { value: '100', label: this.$t('fbb.inventory.sale_outbound_order', { defaultValue: '销售出库单' }) },
                { value: '110', label: this.$t('fbb.inventory.warehouse_out', { defaultValue: '仓库移出' }) },
                { value: '120', label: this.$t('fbb.inventory.warehouse_in', { defaultValue: '仓库移入' }) },
                { value: '121', label: this.$t('fbb.inventory.outside_warehouse_in', { defaultValue: '仓库跨仓移入' }) },
                { value: '122', label: this.$t('fbb.inventory.outside_warehouse_out', { defaultValue: '仓库跨仓移出' }) },
                { value: '103', label: this.$t('fbb.inventory.change_warehouse_in', { defaultValue: '库存调整入库' }) },
                { value: '104', label: this.$t('fbb.inventory.change_warehouse_out', { defaultValue: '库存调整出库' }) },
                { value: '115', label: this.$t('fbb.transfer.transfer_inbound', { defaultValue: "转运入库" }) },
                { value: '116', label: this.$t('fbb.transfer.transfer_outbount', { defaultValue: "转运出库" }) },
                { value: '21', label: this.$t('fbb.transfer.return_outbound', { defaultValue: "退货出库" }) },
                { value: '125', label: this.$t('fbb.transfer.claim_inbound', { defaultValue: "认领入库" }) },
                { value: '126', label: this.$t('fbb.transfer.claim_outbound', { defaultValue: "认领出库" }) },
                { value: '105', label: this.$t('fbb.inventory.change_label_shelf', { defaultValue: "换标下架" }) },
                { value: '106', label: this.$t('fbb.inventory.change_label_put', { defaultValue: "换标上架" }) },
            ];
        },
        getInventoryAdjustmentStatus () {
            return [
                { value: 0, label: this.$t('fbb.alloment.draft', { defaultValue: '草稿' }) },
                { value: 5, label: this.$t('fbb.inbound.check_pending', { defaultValue: '待审核' }) },
                { value: 10, label: this.$t('fbb.inventory.part_processing', { defaultValue: '部分处理' }) },
                { value: 70, label: this.$t('global.upload.complete', { defaultValue: '完成' }) }
            ];
        },
        getAdjustmentBusinessType () {
            return [{
                label: this.$t('bi.work.task_category_other', { defaultValue: '其他' }),
                value: 0,
            },  {
                label: this.$t('fbb.inventory.stock_init', { defaultValue: '库存初始化' }),
                value: 1,
            }, {
                label: this.$t('fbb.misc.send_back', { defaultValue: '借出还回' }),
                value: 2,
            }, {
                label: this.$t('fbb.misc.gift_received', { defaultValue: '赠品接收' }),
                value: 3,
            }, {
                label: this.$t('fbb.misc.inventory_check', { defaultValue: '库存盘点' }),
                value: 4,
            }, {
                label: this.$t('fbb.misc.diff_adjust', { defaultValue: '库存差异调整' }),
                value: 5,
            }, {
                label: this.$t('fbb.misc.common_adjust', { defaultValue: '一般入库接收调整' }),
                value: 6,
            }, {
                label: this.$t('fbb.misc.remove_warehouse', { defaultValue: '移库' }),
                value: 7,
            },
            {
                label: "借出",
                value: 8
            },
            {
                label: this.$t('fbb.misc.remove_other', { defaultValue: '跨仓移库' }),
                value: 10,
            }]
        },
        operateTypeList(){
            return [{
                label: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                value: 500
            },{
                label: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                value: 700
            }, {
                label: this.$t('global.common.finish', { defaultValue: '完成' }),
                value: 800,
            }, {
                label: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                value: 910
            }]
        }
    }
}
